import { useTranslation } from 'react-i18next'

export const SkipToContent = () => {
  const { t } = useTranslation()
  
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
    >
      {t('accessibility.skipToContent', 'Skip to main content')}
    </a>
  )
}

export default SkipToContent
